import EventSeriesList from '../event-series-list';
import MaterialLinkButton from '../material-link-button';
import SectionHeader from '../section-header';
import type { EventSeries } from '../../types/EventSeries';

type Props = {
  eventSeries: EventSeries[];
  editable: boolean;
};

const EventSeriesSection = ({ eventSeries, editable }: Props) => {
  if (eventSeries.length === 0 && !editable) {
    return null;
  }

  return (
    <>
      <SectionHeader>Event series</SectionHeader>

      {eventSeries.length > 0 && (
        <EventSeriesList list={eventSeries} />
      )}

      {editable && (
        <MaterialLinkButton
          href="/event-series/new"
          variant="outlined"
          sx={{ mt: eventSeries.length > 0 ? 0 : undefined }}
        >
          Create event series
        </MaterialLinkButton>
      )}
    </>
  );
};

export default EventSeriesSection;
